import React, { useEffect, useRef } from 'react';
import './boxGeneratorLab.css';
import { mountMakeABox } from './makeABoxEngine';
import { useThemeMode } from '../../app/ThemeModeContext';

export default function BoxGeneratorPage() {
  const rootRef = useRef(null);
  const { isDark } = useThemeMode();

  useEffect(() => {
    const el = rootRef.current;
    if (!el) {
      return undefined;
    }
    const base = typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL !== undefined
      ? String(process.env.PUBLIC_URL).replace(/\/$/, '')
      : '';
    const backgroundSrc = `${base}/box-generator/background.png`;
    return mountMakeABox(el, { backgroundSrc });
  }, []);

  useEffect(() => {
    const el = rootRef.current;
    if (el) {
      el.classList.toggle('bxg-root--dark', isDark);
    }
  }, [isDark]);

  return <div ref={rootRef} style={{ minHeight: '100%' }} />;
}
